module.exports = __webpack_public_path__ + "static/img/app_store.37866918.png";